<template>
    <div class="mod-joylearning__offringlist}">
        <div class="pkg-search-box">
            <el-form
                class="pkg-content"
                label-width="auto"
                label-position="top"
                :model="dataForm"
                @keyup.enter.native="getDataList()"
            >
                <el-row class="margb10">
                    <el-col :span="7">
                        <el-form-item label="规则编号">
                            <el-input
                                maxlength="50"
                                v-model="dataForm.ruleNo"
                                :placeholder="$t('请输入')"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item label="规则名称">
                            <el-input
                                maxlength="50"
                                v-model="dataForm.ruleName"
                                :placeholder="$t('请输入')"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item label="学员ID">
                            <el-input
                                maxlength="50"
                                v-model="dataForm.studentId"
                                :placeholder="$t('请输入')"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3">
                        <el-col :span="24">
                            <el-button
                                class="M-search"
                                style="margin-bottom: 7px"
                                type="primary"
                                @click="getDataListMerge"
                                >{{ $t("course.query") }}
                            </el-button>
                            <el-button
                                class="el-back M-search M-margin-l"
                                type="info"
                                @click="again"
                                >{{ $t("reset") }}
                            </el-button>
                        </el-col>
                    </el-col>
                </el-row>
                <el-row class="margb10">
                    <el-col :span="7">
                        <el-form-item label="学员姓名">
                            <el-input
                                maxlength="50"
                                v-model="dataForm.studentName"
                                :placeholder="$t('请输入')"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item label="排期编号">
                            <el-input
                                maxlength="50"
                                v-model="dataForm.trainingNo"
                                :placeholder="$t('请输入')"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item label="排期名称">
                            <el-input
                                maxlength="50"
                                v-model="dataForm.trainingName"
                                :placeholder="$t('请输入')"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="margb10">
                    <el-col :span="14">
                        <el-form-item style="width: 90% !important;" label="记录时间">
                            <el-date-picker
                                @change="recordTimeChange"
                                v-model="recordTime"
                                type="daterange"
                                value-format="yyyy-MM-dd"
                                range-separator="-"
                                style="width: 100%"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <el-row style="text-align: center; margin-bottom: 10px;">
            </el-row>
        </div>
        <div class="pkg-content">
            <el-table
                v-loading="dataListLoading"
                ref="multipleTable"
                :data="dataList"
                border
                :row-style="{ height: 48 + 'px' }"
                :cell-style="{ padding: 0 + 'px' }"
            >
                <el-table-column
                    prop="orgCategoryNo"
                    label="培训记录编码"
                    header-align="center"
                    align="left"
                    min-width="110"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    prop="orgCategoryNo"
                    label="学员ID"
                    header-align="center"
                    align="left"
                    min-width="110"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    prop="orgCategoryNo"
                    label="学员姓名"
                    header-align="center"
                    align="center"
                    min-width="110"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    prop="orgCategoryNo"
                    label="排期编号"
                    header-align="center"
                    align="center"
                    min-width="110"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    prop="orgCategoryNo"
                    label="排期名称"
                    header-align="center"
                    align="left"
                    min-width="110"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    prop="orgCategoryNo"
                    label="排期开始时间"
                    header-align="center"
                    align="left"
                    min-width="110"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    prop="orgCategoryNo"
                    label="排期结束时间"
                    header-align="center"
                    align="left"
                    min-width="110"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    prop="orgCategoryNo"
                    label="课程编号"
                    header-align="center"
                    align="left"
                    min-width="110"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    prop="orgCategoryNo"
                    label="课程名称"
                    header-align="center"
                    align="left"
                    min-width="110"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    prop="orgCategoryNo"
                    label="规则编号"
                    header-align="center"
                    align="center"
                    min-width="110"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    prop="orgCategoryNo"
                    label="减免原因"
                    header-align="center"
                    align="center"
                    min-width="110"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    prop="orgCategoryNo"
                    label="规则版本号"
                    header-align="center"
                    align="center"
                    min-width="110"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    prop="orgCategoryNo"
                    label="记录类型"
                    header-align="center"
                    align="center"
                    min-width="110"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    prop="orgCategoryNo"
                    label="记录时间"
                    header-align="center"
                    align="center"
                    min-width="110"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <!--操作 -->
                <el-table-column
                :label="$t('offering.operation')"
                fixed="right"
                header-align="center"
                align="center"
                min-width="100"
                >
                    <template slot-scope="scope">
                        <el-link
                        type="primary"
                        :underline="false"
                        @click="gotoView(scope.row)"
                        >查看
                        </el-link>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                :current-page="page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="limit"
                :total="total"
                layout="total, sizes, prev, pager, next, jumper"
                @size-change="pageSizeChangeHandle"
                @current-change="pageCurrentChangeHandle"
            >
            </el-pagination>
        </div>
    </div>
</template>
<script>
import mixinViewModule from "@/mixins/view-module";

export default {
    mixins: [mixinViewModule],
    data() {
        return {
            mixinViewModuleOptions: {
                getDataListURL: "/finance/financeaccount/pageall",
                getDataListIsPage: true,
                exportURL: '/finance/financeaccount/export',
            },
            recordTime: [], // 记录时间
            dataForm: {
                ruleNo: '', // 规则编号
                ruleName: '', // 规则名称
                studentId: '', // 学员id
                studentName: '', // 学员姓名
                trainingNo: '', // 排期编号
                trainingName: '', // 排期名称
                recordTimeS: '', // 记录开始时间
                recordTimeE: '', // 记录结束时间
            }
        };
    },
    methods: {
        // 查询
        getDataListMerge() {
            this.page = 1;
            this.getDataList();
        },
                // 重置
        again() {
            this.dataForm =  {
                ruleNo: '', // 规则编号
                ruleName: '', // 规则名称
                studentId: '', // 学员id
                studentName: '', // 学员姓名
                trainingNo: '', // 排期编号
                trainingName: '', // 排期名称
                recordTimeS: '', // 记录开始时间
                recordTimeE: '', // 记录结束时间
            }
            this.recordTime = [];
            this.page = 1;
            this.getDataList();
        },
        // 记录时间修改
        recordTimeChange() {
            if (this.recordTime && this.recordTime.length > 1) {
                this.dataForm.recordTimeS = this.recordTime[0];
                this.dataForm.recordTimeE = this.recordTime[1];
            } else {
                this.dataForm.recordTimeS = '';
                this.dataForm.recordTimeE = '';
            }
        },
        // 跳转查看
        gotoView(row) {
            this.$router.push({
                name: "ruleSnapshotView",
                params: {
                    row:row,
                },
            });
            this.$eventHub.$emit("ruleSnapshotView", "activated");
        }
    }
}
</script>
<style lang="scss" scoped>
@import "../../../css/pkg-styles.css";

.aui-wrapper .el-date-editor .el-range-separator {
  width: 30px;
}

.jieshu .el-form-item__content {
  width: 94.5%;
}

.kaishi .el-form-item__content {
  width: 111%;
}

.el-row {
  margin-bottom: 0px;
}

#container {
  display: -webkit-flex;
}

.el-date-editor.el-input {
  width: 150px;
}

.search-item {
  width: 94% !important;
  min-width: 290px;
}

.search {
  height: 50px;
}

.wrapper-div {
  .el-dialog__title {
    text-align: center;
    display: block;
  }
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

 .search-item .el-form-item__content {
  margin-left: 96px !important;
}

.margb10 {
  min-height: 75px;
}
</style>
